export default function useDirectusRest() {
  const request = async <T>(options: any) => {
    let response
    try {
      response = await useDirectus<Promise<T>>(options)
    } catch (e) {
      if (!e.errors && e.response._data.errors) {
        e.errors = e.response._data.errors
      }
      throw e
    }
    return response
  }
  return {
    request,
  }
}
